export default "__VITE_ASSET__BYkE5NaO__"